import React from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import * as Style from './style';
import Button from '../../Button';
import color from '../../../../config/colors.json';
import { LoaderLogos } from '../../../Loader';

const ImageUpload = ({
	onDrop,
	accept,
	dropzoneClass,
	uploading,
	buttonMargin,
	buttonStyle,
}) => {
    const {
 getRootProps, getInputProps, isDragActive, open,
} = useDropzone({
 onDrop, accept, noClick: true, disabled: uploading,
});

    return (
	<>
		<Style.Container {...getRootProps({ className: `dropzone ${dropzoneClass}` })}>
			<div className="row" style={{ marginBottom: '0' }}>
				<input {...getInputProps()} />
				<div className="col-12">
					<Style.Label lineheight="24px" fontSize="14px">
						*Nenhum arquivo foi enviado
					</Style.Label>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className="d-flex flex-column align-items-center">
						<Style.UploadIcon />
						{isDragActive
                        ? (<Style.Label labelcolor={color.darkGrey41} fontSize="20px" lineheight="28px">Solte seu logo aqui</Style.Label>)
                        : (<Style.Label labelcolor={color.darkGrey41} fontSize="20px" lineheight="28px">Arraste seu logo aqui </Style.Label>)}
						<Style.Label fontSize="14px" lineheight="21px" labelcolor={color.darkGrey41}>
							Formatos aceitos: JPG e PNG | Tamanho máximo: 25mb
						</Style.Label>
					</div>
				</div>
			</div>
		</Style.Container>
		<div className="row">
			<div className="col-12">
				<div
					style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
				>
					<Style.Label
						style={{ margin: '27px 0 25px' }}
						labelcolor={color.dark}
						fontSize="14px"
						lineheight="21px"
					>
						Ou
					</Style.Label>
					<Button
						fit="true"
						theme={buttonStyle}
						type="button"
						fontWeight="bold"
						padding="10px 15px"
						fontSize="12px"
						margin={buttonMargin}
						onClick={open}
					>
						{
							uploading
							? <LoaderLogos />
							: 'Adicionar logo'
						}
					</Button>
				</div>
			</div>
		</div>
	</>
    );
};

ImageUpload.defaultProps = {
	buttonMargin: '0 0 86px',
	buttonStyle: 'red',
};

PropTypes.ImageUpload = {
	onDrop: PropTypes.func.isRequired,
	accept: PropTypes.string.isRequired,
	dropzoneClass: PropTypes.string.isRequired,
	uploading: PropTypes.bool.isRequired,
	buttonMargin: PropTypes.string,
	buttonStyle: PropTypes.string,
};

export default ImageUpload;
